export default __webpack_public_path__ + "static/media/share.7a6315ad.svg";